import { gql } from '@apollo/client';

export const QUERY_GET_TENANTS = gql`
    query TenantsQuery {
        getTenants {
            id
            name
            description
            url
            tenantType {
                id
                name
            }
            parent {
                id
                name
            }
            coverageZone {
                id
                name
            }
            enabled
            children {
                id
                name
            }
            users {
                id
                firstName
                lastName
                roles {
                    id
                    role {
                        id
                        name
                    }
                }
            }
            whitelistedDomains {
                id
                domain
            }
            mfaRequired
            whitelistedDomains {
                id
                domain
            }
            createdAt
            updatedAt
            tenantType {
                id
                name
            }
        }
    }
`;

export const QUERY_GET_TENANT = gql`
    query TenantFind($filters: TenantFindInput!) {
        TenantFind(data: $filters) {
            id
            email
            name
            lastName
            firstName
            enabled
            createdAt
            updatedAt
            users {
                id
                name
            }
            mfaRequired
        }
    }
`;

export const QUERY_GET_DEFAULT_VALUES_BY_TENANT = gql`
    query FindByTenantIdAndDefaultValues($tenantId: Float!) {
        findByTenantIdAndDefaultValues(tenantId: $tenantId) {
            id
            isDefault
            enabled
            listValues {
                id
                isDefault
            }
        }
    }
`;

export const QUERY_FIND_DOMAINS_FOR_TENANT = gql`
    query FindDomainsForTenant($tenantId: Float!) {
        findDomainsForTenant(tenantId: $tenantId) {
            id
            domain
            enabled
            isTenantSpecific
            tenants {
                id
                name
            }
        }
    }
`;

export const QUERY_FIND_ALL_DOMAINS = gql`
    query FindAllDomains {
        findAllDomains {
            domain
            id
            tenants {
                id
            }
            enabled
            isTenantSpecific
        }
    }
`;
